export default {"src":"/_next/static/media/isotype-line.87e59fd0.svg","height":180,"width":180};